import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import routes from './routes';
import { FacilityProvider } from './context/FacilityContext';
import { AuthProvider } from './context/AuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function App() {
  return (
    <AuthProvider>
      <FacilityProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <Routes>
              {routes.map(({ path, element: Element }, index) => (
                <Route
                  key={index}
                  path={path}
                  element={
                    typeof Element === 'function' ? <Element /> : Element
                  }
                />
              ))}
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
      </FacilityProvider>
    </AuthProvider>
  );
}

export default App;
